'use client';
import React from 'react'
import { GoogleReviewSectionContent, FacebookReviewSectionContent } from '@/lib/types';

// type DevicePartnerBadgeSize = "desktop" | "mobile"

type QRCodeType = "default" | "dropdown";

interface QRCodeProps {
	type: QRCodeType;
	googleReviewSectionPageData: GoogleReviewSectionContent;
	facebookReviewSectionPageData: FacebookReviewSectionContent;
	selectedBranch?: string | null;
	/** When set, the QR code becomes a link that opens this URL in a new tab.
	 *  Without it the QR renders as a plain non-interactive tile. */
	href?: string;
}

// const PARAMS_TO_SVG: Record<DevicePartnerBadgeSize, string> = {
// 	desktop:
// 		'/QR-Desktop.svg',
// 	mobile:
// 		'/QR-Mobile.svg',
// }


const QRCode: React.FC<QRCodeProps> = ({
	type,
	googleReviewSectionPageData,
	facebookReviewSectionPageData,
	selectedBranch,
	href
}) => {
	const baseClassName = `
		border-secondary
		border-theme-yellow-primary-base
		p-[2rem]
		border-radius-main
		w-fit
		bg-black-white-off-white
		${href ? 'cursor-pointer no-underline' : ''}
	`;

	const imageSrc = type === "default"
		? googleReviewSectionPageData.googleReviewQR.url
		: facebookReviewSectionPageData.facebookReviews.find(review => review.branch?.branchName === selectedBranch)?.facebookReviewQR.url || '';

	const image = (
		<img
			//  src={PARAMS_TO_SVG[isLg ? "desktop" : "mobile"]}
			src={imageSrc}
			alt="QR Code"
			className='self-center'
		/>
	);

	if (href) {
		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className={baseClassName}
			>
				{image}
			</a>
		);
	}

	return (
		<div className={baseClassName}>
			{image}
		</div>
	);
}

export default QRCode;
